<template>
  <div class="h-full w-850px mx-auto pb-20px">
    <template v-if="currentData.form">
      <k-form-build ref="kfb" :value="currentData.form"></k-form-build>
      <div class="flex justify-center" v-if="!bizId">
        <a-button @click="handleReset" type="default">清空</a-button>
        <a-button @click="submitData" type="primary" class="ml-10px">保存</a-button>
      </div>
    </template>
    <div v-else class="text-center">
      当前无交接班表单设计<a-button type="link" @click="goDesigner()">立即前往</a-button>
    </div>
  </div>
</template>

<script>
import { KFormBuild } from '@/components/KFormDesign/packages/index.js'
import { getAction, postAction } from '@/api/manage'

export default {
  name: 'OperatorRecordForm',
  components: {
    KFormBuild
  },

  // 定义属性
  data() {
    return {
      loading: false,
      currentData: {
        id: '',
        form: '',
        list: [],
        fillData: {},
        fillList: []
      },
      bizId: ''
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    btnText() {
      return this.currentData?.fillList.length > 0 ? '修改' : '保存'
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.loadDesigner()
  },
  // 方法集合
  methods: {
    goDesigner() {
      this.$router.push({ path: '/tech/form-playground' })
    },
    async loadDesigner() {
      const sysOrgCode = this.$store.state.user.info.orgCode
      await getAction('/custom/customForm/list', {
        bizType: 1,
        sysOrgCode
      })
        .then(res => {
          if (res.success) {
            const { records } = res.result
            if (records.length > 0) {
              const { formJson, list } = records[0]
              this.currentData.form = JSON.parse(formJson)
              this.currentData.list = list ?? []
            }
          }
        })
        .finally(e => {
          this.loading = true
        })

      //区分是否是值班记录的详情页面
      if (this.bizId) {
        this.currentData.id = this.bizId
      } else {
        // 获取交接班当前记录
        await getAction('/duty/dutyRecord/getCurrentDutyRecord').then(res => {
          if (res.success) {
            this.currentData.id = res.result?.id ?? ''
          }
        })
      }
      // 获取交接班当前记录填写的数据
      await getAction('/custom/customFormRecord/getListByBizId', {
        bizId: this.currentData.id
      }).then(res => {
        if (res.success) {
          if (res.result) {
            const { list = [] } = this.currentData
            const fill = list.reduce(
              (pre, cur) => {
                const item = res.result.find(item => item.cfpId == cur.id)
                if (item) {
                  pre.data[cur.propKey] =
                    cur.dataType == 'string'
                      ? item.propValue
                      : item.propValue?.split(',')?.map(v => {
                          return v
                        }) ?? []
                }
                pre.list.push(cur)
                return pre
              },
              { data: {}, list: [] }
            )
            this.$refs.kfb.setData(fill.data)
            this.currentData.fillData = fill.data
            this.currentData.fillList = res.result
          }
        }
      })
    },
    submitData() {
      const { list = [], id: bizId, fillList } = this.currentData

      if (!bizId) {
        return this.$message.error('当前没有值班记录，无法保存！')
      }
      this.$refs.kfb.getData().then(values => {
        console.log('验证通过', values)

        const customFormRecord = list.reduce((pre, cur) => {
          const v =
            Object.prototype.toString.call(values[cur.propKey]) == '[object Array]'
              ? values[cur.propKey].join()
              : values[cur.propKey] ?? ''

          const listItem = {
            bizId: bizId,
            cfId: cur.cfId,
            cfpId: cur.id,
            propValue: v
          }
          const { id: fillId = 0 } = fillList.find(fill => fill.cfpId == cur.id) || {}
          if (fillId) {
            listItem.id = fillId
          }
          pre.push(listItem)
          return pre
        }, [])

        // batchSaveOrUpdate

        const url = `/custom/customFormRecord/batchSaveOrUpdate`

        postAction(url, customFormRecord).then(res => {
          if (res.success) {
            this.$message.success('保存成功')
            this.handleReset()

            if (this.bizId) {
              this.$emit('ok')
              return
            }
            this.loadDesigner()
          }
        })
      })
      // .catch(() => {
      //   console.log('验证未通过，获取失败')
      // })
    },
    handleReset() {
      this.$refs.kfb.reset()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
